<template>
  <div>
    <Toast />
    <Dialog modal :visible="is_visible" :closable="false">
      <ProgressSpinner style="width: 50px; height: 50px; display:block; margin:auto;" strokeWidth="8" fill="transparent"
        animationDuration=".5s" aria-label="Custom ProgressSpinner" />
        <p style="text-align: center; font-size: 1em;">Iniciando sesion</p>
    </Dialog>
    <div class="iconcard">
      <img src="../assets/administrador.png" alt="">
    </div>
    <div style="width:80%; margin: auto;">
      <h1 style="font-size: 20px; text-align: center;">Control de Clientes</h1>
      <p style="font-size: 14px; text-align: center;">Clientes y contactos en un solo lugar</p><br>
      <div class="linear-form"></div>
      <div class="formulario-login">
        <div class="form-content">
          <br>
          <img src="../assets/logo.png" alt="">
          <br>
          <label style="margin-bottom: 10px; display: block; font-size: 14px;">Correo Electronico</label>
          <IconField>
            <InputIcon class="pi pi-user" />
            <InputText v-model="username" @keyup.enter="login()" style="width: 100%; " placeholder="example@s.com" />
          </IconField>
          <br>
          <label style="margin-bottom: 10px; display: block; font-size: 14px;">Contraseña</label>
          <IconField>
            <InputIcon class="pi pi-lock" />
            <Password v-model="password" toggleMask :feedback="false"  placeholder="******"  @keyup.enter="login()" inputClass="w-full"/>
          </IconField>
          <br><br>
          <Button label="Iniciar Sesion" class="btn-login"  icon="pi pi-arrow-right" @click="login()"/>
          <br>
        </div>
      </div>
      <br>
      <p style="text-align: center; font-size: 14px;">2026 ® EC Logistics   Todos los derechos reservados.</p>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { useToast } from 'primevue/usetoast';
import { IconField, InputText, InputIcon, Password, Button, Toast,ProgressSpinner, Dialog } from 'primevue';
import { ref } from 'vue';
import api from '@/plugins/Axios';
import { useRouter } from 'vue-router';


const toast = useToast();
const username = ref("");
const password = ref("");
const router = useRouter();
const is_visible = ref(false);

const login = async () =>{
  try{
    is_visible.value = true;
    let usuario = username.value;
    let pass = password.value;

    if(usuario == "")
    {
      is_visible.value = false;
      toast.add({ severity: 'error', summary: 'error', detail: 'El campo correo esta vacío', life: 3000 });
      return false;
    }

    if(pass == "")
    {
      is_visible.value = false;
      toast.add({ severity: 'error', summary: 'error', detail: 'El campo contraseña esta vacío', life: 3000 });
      return false;
    }

    let form = new FormData();
    form.append("login", "");
    form.append("email", usuario);
    form.append("password", pass);
    const res = await api.post("/Api_Usuario", form);
    console.log(res.data);
    if(res.data.message=="completo")
    {
      setTimeout(() => {
        is_visible.value = false;
        toast.add({ severity: 'success', summary: 'Success', detail: 'Message Content', life: 3000 });
        localStorage.setItem("token", res.data.token);
        router.push("/dashboard");
      }, 500);
    }
    else
    {
      toast.add({ severity: 'error', summary: 'Error', detail: res.data.message, life: 3000 });
      is_visible.value = false;
    }
  }
  catch(err)
  {
    console.error(err);
    is_visible.value = false;
  }
}


</script>

<style scoped>

.linear-form{
  width: 30%;
  margin: auto;
  background: rgb(19, 109, 236);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 3px;
}
.form-content{
  width: 90%;
  margin: auto;
}
.formulario-login{
  width: 30%;
  box-shadow: 0px 0px 4px silver;
  padding: 10px;
  margin: auto;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background: white;
}
.iconcard{
  width: 50px;
  height: 50px;
  margin: 5% auto auto auto;
  border-radius: 12px;
  background: rgb(19, 109, 236);
  box-shadow: 0px 0px 4px black;
  padding: 8px;
}
.iconcard img{
  display: block;
  margin: auto;
}
.form-content img{
  width: 100px;
  height: 80px;
  display: block;
  margin: auto;
}
.btn-login
{
  padding: 10px; 
  width: 100%;
  background: rgb(19, 109, 236); 
  color: white; 
  border: none;
  transition: all .45s;
}
.btn-login:hover
{
  transition: all .45s;
  transform: scale(1.05,1.05);
  background: rgb(19, 109, 236) !important; 
  color: white !important; 
  border: none !important;
}
@media(max-width:1200px)
{
  .linear-form
  {
    width: 50%;
    transition: all .45s;
  }
  .formulario-login
  {
    width: 50%;
    transition: all .45s;
  }
}
@media(max-width:750px)
{
  .linear-form
  {
    width: 70%;
    transition: all .45s;
  }
  .formulario-login
  {
    width: 70%;
    transition: all .45s;
  }
}

@media(max-width:550px)
{
  .linear-form
  {
    width: 95%;
    transition: all .45s;
  }
  .formulario-login
  {
    width: 95%;
    transition: all .45s;
  }
}

@media (prefers-color-scheme: dark) {
  .formulario-login {
    background: rgb(0, 0, 0);
    box-shadow: 0px 4px 5px rgb(0, 0, 0);
  }
}
</style>